export const fluentExperiments = {
  fluentV9RibbonButtonIsEnabled: "SharedOnline.FluentV9RibbonButtonEnabled",
  fluentV9ButtonIsEnabled: "FluentV9ButtonBRSIsEnabled",
  fluentV9CompoundButtonIsEnabled: "SharedOnline.FluentV9CompoundButtonEnabled",
  fluentV9CheckboxIsEnabled: "SharedOnline.FluentV9CheckboxEnabled",
  fluentV9HeaderButtonIsEnabled: "SharedOnline.FluentV9HeaderButtonEnabled",
  fluentV9StatusBarButtonEnabled: "SharedOnline.FluentV9StatusBarButtonEnabled",
  fluentV9InputComboboxIsEnabled: "SharedOnline.FluentV9InputComboboxEnabled",
  fluentV9StatusBarSliderEnabled: "SharedOnline.FluentV9StatusBarSliderEnabled",
  fluentV9PersonaButtonIsEnabled: "SharedOnline.FluentV9PersonaButtonEnabled",
  fluentV9ContextMenuIsEnabled: "SharedOnline.FluentV9ContextMenuEnabled",
  fluentV9FloatieIsEnabled: "SharedOnline.FluentV9FloatieEnabled",
  fluentV9MessageBarIsEnabled: "SharedOnline.FluentV9MessageBarEnabled",
  fluentV9TaskPaneControlsEnabled:
    "SharedOnline.FluentV9TaskPaneControlsEnabled",
  fluentV9ToggleIconEnabled:
    "SharedOnline.ChangeGate.FluentV9ToggleIconEnabled",
  fluentV9TabListSpinButtonFocusIsEnabled:
    "SharedOnline.FluentV9TabSpinFocusIsEnabled",
  fluentV9TaskPaneIsEnabled: "SharedOnline.FluentV9TaskPaneIsEnabled",
  fluentV9DialogIsEnabled: "SharedOnline.FluentV9DialogEnabled",
  // TASK 9079618: Move disableTaskpaneRefreshStyling to platformFeatures
  disableTaskpaneRefreshStyling: "DisableTaskpaneRefreshStyling",
  fluentV9RibbonControlsIsEnabled:
    "SharedOnline.FluentV9RibbonControlsIsEnabled",
};
